import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { makeApiRequest } from '../../shared/api';
import { getCookie } from 'cookies-next';
import { Spin } from 'antd';

const Reports = () => {
  const { dashboardID } = useParams();
  const dashboardRef = useRef(null);
  const [dashboardUrl, setDashboardUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const dashboardInstance = useRef(null);


  const token = getCookie("accessToken");

  useEffect(() => {
    const fetchDashboardUrl = async() => {
      try {
        const config = await makeApiRequest('GET', 'app/config');
        const matching = config.reports?.find(d => d.dashboardID === dashboardID);

        if (!matching) {
          throw new Error('Dashboard not found in config');
        }

        setDashboardUrl(matching.url);
      } catch (err) {
        console.error(err);
        setError('Dashboard not found or misconfigured.');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardUrl();
  }, [dashboardID]);

  useEffect(() => {
    if (!dashboardUrl || !dashboardID) return;

    const sdk = new ChartsEmbedSDK({
      baseUrl: dashboardUrl,
      getUserToken: () => token
    });

    const loadDashboard = async() => {
      try {
        const dashboard = sdk.createDashboard({ dashboardId: dashboardID });
        dashboardInstance.current = dashboard;

        await dashboard.render(dashboardRef.current);
      } catch (err) {
        console.error(err);
        setError('Error rendering dashboard.');
      }
    };

    loadDashboard();

    return () => {
      dashboardInstance.current?.destroy?.();
    };
  }, [dashboardUrl, dashboardID]);

  if (loading){
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return <div ref={dashboardRef} style={{ height: '80vh' }} />;
};

export default Reports;
